/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

 $(document).ready(function(){
  if( $(document).find('.ait-testimonial-slider').length ){  	    
      $(document).find('.ait-testimonial-slider').slick({
        dots: false,
        arrows: true,
        prevArrow:'<button class="flickity-prev-next-button previous" type="button" aria-label="previous"><svg viewBox="0 0 100 100"><path d="M 20,50 L 60,90 L 60,85 L 25,50  L 60,15 L 60,10 Z" class="arrow"></path></svg></button>',
        nextArrow:'<button class="flickity-prev-next-button next" type="button" aria-label="next"><svg viewBox="0 0 100 100"><path d="M 20,50 L 60,90 L 60,85 L 25,50  L 60,15 L 60,10 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></button>',
        infinite: true,
        //autoplay:true,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1
            }
          }
          // You can unslick at a given breakpoint now by adding:
          // settings: "unslick"
          // instead of a settings object
        ]
      });
  }  
  if( $(document).find('.ait-sticky-add-to-cart').length ){
    $(document).find('body').css('padding-bottom',$(document).find('.ait-sticky-add-to-cart').height());
  } 
   $(window).scroll(function(){
      if( $(document).find('.ait-sticky-add-to-cart').length ){
        $(document).find('body').css('padding-bottom',$(document).find('.ait-sticky-add-to-cart').height());
      }   
   });
});






$(document).ready(function(){
    $('.customer-logos').slick({
        slidesToShow: 6,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        arrows: false,
        dots: false,
        pauseOnHover: false,
        responsive: [{
            breakpoint: 768,
            settings: {
                slidesToShow: 4,
                autoplaySpeed: 800,
                speed: 150
            }
        }, {
            breakpoint: 520,
            settings: {
                slidesToShow: 2,
                autoplaySpeed: 800,
                speed: 150
            }
        }]
    });
});



$(document).ready(function(){
    $('.customer-logos1').slick({
        slidesToShow: 2,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        arrows: false,
        dots: false,
        pauseOnHover: false,
        responsive: [{
            breakpoint: 768,
            settings: {
                slidesToShow: 2
            }
        }, {
            breakpoint: 520,
            settings: {
                slidesToShow: 1
            }
        }]
    });
});


$(document).ready(function(){
    $('.customer-logos2').slick({
        slidesToShow: 2,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        arrows: false,
        dots: false,
        pauseOnHover: false,
        responsive: [{
            breakpoint: 768,
            settings: {
                slidesToShow: 2
            }
        }, {
            breakpoint: 520,
            settings: {
                slidesToShow: 1.05
            }
        }]
    });
});


$(document).ready(function(){
    $('.customer-logos3').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        arrows: true,
      prevArrow:'<button class="flickity-prev-next-button previous" type="button" aria-label="previous"><svg viewBox="0 0 100 100"><path d="M 20,50 L 60,90 L 60,85 L 25,50  L 60,15 L 60,10 Z" class="arrow"></path></svg></button>',
       nextArrow:'<button class="flickity-prev-next-button next" type="button" aria-label="next"><svg viewBox="0 0 100 100"><path d="M 20,50 L 60,90 L 60,85 L 25,50  L 60,15 L 60,10 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></button>',
        dots: false,
        pauseOnHover: false,
        responsive: [{
            breakpoint: 768,
            settings: {
                slidesToShow: 2
            }
        }, {
            breakpoint: 520,
            settings: {
                slidesToShow: 1
            }
        }]
    });
});
document.addEventListener('click', function(e) {
  var btn = e.target.closest('[data-action="add-to-cart"]');
  if (btn) {
    var form = btn.closest('form');
    if (form && !form.closest('#sidebar-cart')) {
      e.preventDefault();
      fetch('/cart/add.js', {
        method: 'POST',
        body: new FormData(form)
      })
      .then(function() {
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        var trigger = document.querySelector('[data-action="open-drawer"][data-drawer-id="sidebar-cart"]');
        if (trigger) {
          trigger.click();
        }
      });
    }
  }
});
// Cart upsell add button
document.addEventListener('click', function(e) {
  var btn = e.target.closest('.CartUpsell__Add');
  if (btn) {
    e.preventDefault();
    var variantId = btn.getAttribute('data-variant-id');
    btn.textContent = '...';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    }).then(function() {
      btn.textContent = '✓ Added';
      // Try multiple refresh methods this theme may use
      fetch('/cart.js')
        .then(r => r.json())
        .then(function(cart) {
          document.querySelectorAll('[data-cart-count]').forEach(el => el.textContent = cart.item_count);
          document.querySelectorAll('.CartCount').forEach(el => el.textContent = cart.item_count);
          // Trigger theme cart update events
          document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          window.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
        });
    });
  }
});